import {useCallback, useMemo, useState} from 'react';
import {ScrollViewProps} from 'react-native';
import {ScrollViewMapProps} from '../types';

export interface UseScrollViewMapReturnValue {
  scrollViewProps: Pick<ScrollViewProps, 'scrollEnabled'>;
  mapProps: ScrollViewMapProps;
}
export function useScrollViewMap(): UseScrollViewMapReturnValue {
  const [scrollEnabled, setScrollEnabled] = useState(true);

  const onTouchStart = useCallback(() => {
    setScrollEnabled(false);
  }, []);

  const onTouchEnd = useCallback(() => {
    setScrollEnabled(true);
  }, []);

  const onTouchCancel = useCallback(() => {
    setScrollEnabled(true);
  }, []);

  const scrollViewProps = useMemo(
    () => ({
      scrollEnabled,
    }),
    [scrollEnabled],
  );

  const mapProps = useMemo(
    () => ({
      scrollGesturesEnabled: true,
      onTouchStart,
      onTouchEnd,
      onTouchCancel,
    }),
    [onTouchStart, onTouchEnd, onTouchCancel],
  );

  return {
    scrollViewProps,
    mapProps,
  };
}
